import ReactiveDao from "reactive-dao"
import ReactiveSockJS from "reactive-dao-sockjs"
import Vue from 'vue'

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4()
}

let sessionId = localStorage.sessionId
if(!sessionId) {
  sessionId = guid()
  localStorage.sessionId = sessionId
}
document.cookie = `sessionId=${sessionId}`

let api =  new ReactiveDao(sessionId, {

  remoteUrl: document.location.protocol + '//' + document.location.host + "/sockjs",

  connectionSettings: {
    requestSendTimeout: 1200,
    queueRequestsWhenDisconnected: true
  },

  protocols: {
    'sockjs': ReactiveSockJS
  },

  user: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  emailPassword: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  session: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  save: {
    type: "remote",
    generator: ReactiveDao.ObservableList
  },
  subscription: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  foxyCart: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  geoip: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  logs: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  config: {
    type: "remote",
    generator: ReactiveDao.ObservableList
  }

})

api.session = new Vue({
  data: {
    session : null
  },
  computed: {
    loggedIn() {
      return this.session && !!this.session.userId
    },
    roles() {
      return (this.session && this.session.roles) || []
    },
    premium() {
      return this.roles && this.roles.indexOf("premium") != -1
    }
  },
  watch: {
    session(sess) {
      document.querySelector("#preconnect").style.display = sess != null ? "none" : "flex"
    }
  },
  created() {
    api.observable(["session","currentSession"]).bindProperty(this, 'session')
  }
})

export default api



// WEBPACK FOOTER //
// ./src/api/index.js